export enum AdType {
    YahooVerizon,
    AppNexus,
}
